import React from 'react'

const Stack = () => {
    return (
        <div className='container'>
            <h1>Stack</h1>
            <p>A stack is a linear data structure, collection of items of the same type. <br />

Stack follows the Last In First Out (LIFO) fashion wherein the last element entered is the first one to be popped out. <br />

In stacks, the insertion and deletion of elements happen only at one endpoint of it. <br /></p>
        <h3>1. Operations performed on Stacks</h3>
        The following are the basic operations served by the Stacks. <br />
        <b>Push</b>: This function adds an element to the top of the Stack. <br />
        <b> Pop</b>: This function removes the topmost element from the stack. <br />
        <b> IsEmpty</b>: Checks whether the stack is empty. <br />
        <b>IsFull</b>: Checks whether the stack is full. <br />
        <b>Top</b>: Displays the topmost element of the stack. <br />
        <h3>2. Working of Stacks</h3>
        Initially, we set a pointer Peek/Top to keep the track of the topmost item in the stack. <br />
        <br />
Initialize the stack to -1. Then, we check whether the stack is empty through the comparison of Peek to -1 i.e. Top == -1<br />
<br />
As we add the elements to the stack, the position of the Peek element keeps updating every time.<br />
<br />
As soon as we pop or delete an item from the set of inputs, the top-most element gets deleted and thus the value of Peek/Top gets reduced.<br />
<h1>3. Implementing Stack in C</h1>
Stacks can be represented using structures, pointers, arrays or linked lists. <br />
<br />
Here, We have implemented stacks using arrays in C. <br />
<div className='containers'>
 <code className='library'> #include</code>&lt;stdio.h&gt;<br />
 <br />
 <code className='library'>#include</code>&lt;stdlib.h&gt;<br />
 <br />
 <code className='keywords'>#define </code>Size 4 <br />
 <br />
 <code className='keywords'>int</code> Top=-1, inp_array[Size];<br />
 <code className='keywords'>void</code> Push();<br />
 <code className='keywords'>void</code> Pop();<br />
 <code className='keywords'>void</code> show();<br />
 <br />
 <code className='library'>int</code> main()<br />
 &#123;<br />
 <code className='library'>  int</code> choice;<br />
      
 <code className='keywords'>  while</code>(1)    
     &#123;<br />
     <code className='library'>  printf</code>("\nOperations performed by Stack");<br />
     <code className='library'>  printf</code>("\n1.Push the element\n2.Pop the element\n3.Show\n4.End");<br />
     <code className='library'> printf</code>("\n\nEnter the choice:");<br />
     <code className='library'> scanf</code>("%d",&choice);<br />
          
     <code className='library'>  switch</code>(choice)
         &#123;<br />
         <code className='keywords'>    case 1</code>: Push();<br />
         <code className='library'>          break;<br /></code>
         <code className='keywords'>  case 2: Pop();<br /></code>
         <code className='library'>          break;<br /></code>
         <code className='keywords'> case 3: show();<br /></code>
         <code className='library'>         break;<br /></code>
         <code className='keywords'> case 4</code>: exit(0);<br />
              
         <code className='keywords'>  default</code>: printf("\nInvalid choice!!");<br />
         &#125;<br />
     &#125;<br />
 &#125;<br />
   
 <code className='keywords'>void</code> Push()
 &#123;<br />
 <code className='keywords'> int</code> x<br />
      
 <code className='keywords'> if</code>(Top==Size-1)
     &#123;<br />
     <code className='library'>     printf</code>("\nOverflow!!")<br />
     &#125;<br />
     <code className='keywords'> else</code>
     &#123;<br />
     <code className='library'>   printf</code>("\nEnter element to be inserted to the stack:")<br />
     <code className='library'>   scanf</code>("%d",&x)<br />
         Top=Top+1<br />
          inp_array[Top]=x<br />
     &#125;<br />
 &#125;<br />
   
 <code className='keywords'>void</code> Pop()
 &#123;<br />
 <code className='keywords'>  if </code>(Top==-1)
     &#123;<br />
     <code className='library'>     printf</code>("\nUnderflow!!")<br />
     &#125;<br />
     <code className='keywords'>  else </code>
     &#123;<br />
     <code className='library'>   printf</code>("\nPopped element:  %d",inp_array[Top])<br />
         Top=Top-1<br />
     &#125;<br />
 &#125;<br />
   
 <code className='keywords'>void</code> show()
 &#123;<br />
      
      
 <code className='keywords'>if</code>(Top==-1)
     &#123;<br />
     <code className='library'>  printf</code>("\nUnderflow!!")<br />
     &#125;<br />
     <code className='keywords'>  else</code>
     &#123;<br />
     <code className='library'>    printf</code>("\nElements present in the stack: \n")<br />
     <code className='keywords'>    for</code>(int i=Top;i&gt;=0;--i)
     <code className='library'>       printf</code>("%d\n",inp_array[i])<br />
     &#125;<br />
 &#125;<br />
</div>
        </div>
    )
}

export default Stack
